var _circle, _circle2, _circle3, _g, _circle4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAssuredSellback = function SvgAssuredSellback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 16.875,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "AssuredSellback_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 34,
    height: 34
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 16.875,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#AssuredSellback_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 31.875,
    cy: 33.75,
    r: 16.875,
    fill: "#93A0E0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.196 25.982H25.18a.804.804 0 0 1 0-1.607h9.642a.804.804 0 0 1 0 1.607h-2.41c.35.467.602 1.014.723 1.607h1.687a.804.804 0 0 1 0 1.608h-1.687a4.02 4.02 0 0 1-3.938 3.214h-.47l5.056 5.057a.804.804 0 0 1-1.136 1.136l-6.428-6.428a.804.804 0 0 1 .568-1.372h2.41c1.05 0 1.944-.671 2.274-1.607h-6.291a.804.804 0 0 1 0-1.608h6.29a2.411 2.411 0 0 0-2.273-1.607Z",
    fill: "#222"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 16.375,
    stroke: "#222"
  })));
};
export default SvgAssuredSellback;